import { useCallback } from 'react';

import type { DispatchState } from 'common/types/React';

interface UseAfterSlideHandlerOptions {
  viewedItems: number[];
  setViewedItems: DispatchState<number[]>;
}

export const useAfterSlideHandler = ({
  viewedItems,
  setViewedItems,
}: UseAfterSlideHandlerOptions) =>
  useCallback(
    (currentSlide: number) => {
      if (!viewedItems.includes(currentSlide)) {
        setViewedItems([...viewedItems, currentSlide]);
      }
    },
    [viewedItems, setViewedItems]
  );
